import { render, staticRenderFns } from "./CreateAppSpecificData.vue?vue&type=template&id=8fe814c6&"
import script from "./CreateAppSpecificData.vue?vue&type=script&lang=js&"
export * from "./CreateAppSpecificData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports